import moment from 'moment';
import Vue from 'vue';
// import excel from 'vue-excel-export';
import VueExcelXlsx from 'vue-excel-xlsx';
import App from './App.vue';
import Http from './plugins/http';
import { UtilsPlugin } from './plugins/utils';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import VuetifyConfirm from 'vuetify-confirm';
import { useAppInsights } from './utils/appInsights'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import ErrorService from './services/erroService';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';


// Configurações do Vue...



Vue.config.productionTip = false;

Vue.use(UtilsPlugin);
Vue.use(new Http());
// Vue.use(excel);
Vue.use(VueExcelXlsx);

// Criando um evento só para garantir que carregamos tudo
useAppInsights().trackEvent({ name: 'App Loaded!' });

Sentry.init({
  Vue,
  dsn: "https://03a7e13c737344209bf199d2398d97bf@o1306182.ingest.sentry.io/4503976580153344",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay()
  ],
  environment: process.env.NODE_ENV,  
  debug: false,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1,
  tracingOptions: {
    trackComponents: true,
  },
  // Vue specific
  logErrors: process.env.NODE_ENV === 'production' ? false : true,
  attachProps: true,
  attachStacktrace: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

});

Vue.config.errorHandler = (error) => ErrorService.onError(error);

moment.locale('en-US');

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  buttonTrueColor: '#013767',
  buttonFalseColor: 'grey',
  buttonTrueFlat: false,
  buttonFalseFlat: true,
  color: '#013767',
  icon: 'mdi-alert',
  title: 'Warning',
  width: 350,
  property: '$confirm'
});

Vue.use(VueSweetalert2);


